import axios from "axios"
export function reopenZelleDetails(userId, token) {
    return axios.get(process.env.REACT_APP_API_URL + `/reopenZelleDetails?userId=${userId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}